import styled from "styled-components";
import { media } from "../../../../utils";

export const MobileImage = styled.img`
  ${media.md()} {
    display: none;
  }
`;

export const BodySectionContent = styled.div`
  display: flex;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const Description = styled.span({
  [media.md()]: {
    strong: {
      fontWeight: "500",
      fontSize: "32px",
    },
  },
});

export const BodySectionContentText = styled.div({
  padding: "0 8px",
  [media.lg()]: {
    padding: "0",
  },
});

export const BodyOverride = styled.div({
  [media.lg()]: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
  },
});
